(() => {
  'use strict';
  if (!window.customElements || customElements.get('printique-poster-benefits')) return;
  customElements.define('printique-poster-benefits', class extends HTMLElement {
    connectedCallback() {
      if (this.observer) return;
      const source = this.querySelector('template');
      const scope = this.closest('.product-details');
      if (!source || !scope) return;
      this.list = source.content.firstElementChild.cloneNode(true);
      const mount = () => {
        if (!this.isConnected) return;
        const price = scope.querySelector('.tee-product-price');
        if (price && price.nextElementSibling !== this.list) price.insertAdjacentElement('afterend', this.list);
      };
      this.observer = new MutationObserver(() => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; mount(); });
      });
      this.observer.observe(scope, {childList: true, subtree: true});
      mount();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.observer = null;
      cancelAnimationFrame(this.frame);
      this.frame = null;
      this.list?.remove();
    }
  });
})();
